export default __webpack_public_path__ + "static/media/rfidGen.79109593.png";